/**
 * LanguageSelector.jsx - Seletor de Idioma
 * CG Business ERP
 */

import { useLanguage, translations } from '@/i18n';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';
import { toast } from 'sonner';

export default function LanguageSelector({ variant = 'ghost', showLabel = false }) {
  const { language, setLanguage, t, languages } = useLanguage();

  const handleLanguageChange = async (lang) => {
    await setLanguage(lang);
    const langName = languages[lang].name;
    const changeMessage = translations[lang]?.language?.changed || t('language.changed');
    toast.success(changeMessage.replace('{{language}}', langName));
  };

  const currentLang = languages[language];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant}
          size="sm"
          className="gap-2"
          title={t('language.title')}
          data-testid="language-selector-button"
        >
          <span className="text-base">{currentLang.flag}</span>
          {showLabel && <span className="text-xs">{currentLang.code.toUpperCase()}</span>}
          {!showLabel && <Globe className="h-4 w-4" />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]" data-testid="language-selector-menu">
        {Object.values(languages).map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => {
              void handleLanguageChange(lang.code);
            }}
            className={`gap-2 cursor-pointer ${language === lang.code ? 'bg-accent' : ''}`}
            data-testid={`language-selector-option-${lang.code}`}
          >
            <span className="text-base">{lang.flag}</span>
            <span>{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
